// Единый диалог подтверждения вместо нативного window.confirm().
// Возвращает Promise<boolean>: true — пользователь подтвердил действие.
// Рендерится компонентом ConfirmDialog (смонтирован в App.js), который
// слушает событие app:confirm.
//
// Опции:
//   title       — короткий вопрос («Удалить раздел?»)
//   message     — пояснение простым языком, что произойдёт
//   confirmText — надпись на кнопке действия («Удалить»)
//   cancelText  — надпись на кнопке отказа («Оставить»)
//   confirmHint — тултип: что сделает кнопка действия
//   cancelHint  — тултип: что сделает кнопка отказа
//   danger      — false, если действие не разрушительное (кнопка акцентная, не красная)
export const confirmDialog = (options = {}) => new Promise((resolve) => {
    try {
        window.dispatchEvent(new CustomEvent('app:confirm', { detail: { ...options, resolve } }));
    } catch (_) {
        // Fallback, если CustomEvent недоступен
        // eslint-disable-next-line no-alert
        resolve(window.confirm(options.message || options.title || ''));
    }
});
